import { render, staticRenderFns } from "./MainBanners.vue?vue&type=template&id=ef1db80c&scoped=true"
import script from "./MainBanners.vue?vue&type=script&lang=ts"
export * from "./MainBanners.vue?vue&type=script&lang=ts"
import style0 from "./MainBanners.vue?vue&type=style&index=0&id=ef1db80c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef1db80c",
  null
  
)

export default component.exports